// extracted by mini-css-extract-plugin
export default {"panel":"CategoryData_panel__vF+r1","content":"CategoryData_content__qu-yn","section":"CategoryData_section__9v5hr","actionContent":"CategoryData_actionContent__IyYNt"};